import { Link } from "react-router-dom";
import { Eyebrow, FadeUp, MaskedLine } from "@/components/motion";

const SECTIONS = [
  {
    title: "What we collect",
    body: "When you join the Players List we collect your first name, email address, and — if you choose to share them — your mobile number, age and position preference. When you contact us, we collect your first name, email and your message. Nothing more.",
  },
  {
    title: "Why we collect it",
    body: "Your details are used to communicate with you about upcoming gatherings and to help us create balanced, comfortable rooms. Preference questions exist only to help the mix — never to judge appearance.",
  },
  {
    title: "Who sees it",
    body: "Your information is confidential to the Players Lounge hosts. It is never published, sold, or shared with other Players or third parties beyond the secure mailing service we use to send invitations (Brevo).",
  },
  {
    title: "Discretion at events",
    body: "Players Lounge has a strict no-photography and no-filming policy. Venue addresses are shared only with confirmed Players shortly before each gathering. What happens in the Lounge stays in the Lounge — we expect the same discretion from every guest.",
  },
  {
    title: "Your choices",
    body: "You can ask us at any time to see, correct or delete the details we hold about you. Joining the Players List never obliges you to attend anything.",
  },
];

const Privacy = () => (
  <div data-testid="privacy-page">
    <section className="lamp-glow mx-auto max-w-7xl px-5 pb-14 pt-36 sm:px-8 sm:pt-44">
      <Eyebrow suit="♠">Privacy</Eyebrow>
      <h1 className="mt-4 font-serif text-5xl leading-[1.02] tracking-tight text-ivory sm:text-6xl">
        <MaskedLine delay={0.1}>Discretion,</MaskedLine>
        <MaskedLine delay={0.25} className="italic text-brass">
          in writing.
        </MaskedLine>
      </h1>
      <FadeUp delay={0.4}>
        <p className="mt-7 max-w-2xl text-lg leading-relaxed text-ivory/70">
          A plain-language note on what we collect, why, and how it's protected.
        </p>
      </FadeUp>
    </section>

    <section className="mx-auto max-w-3xl space-y-6 px-5 pb-24 sm:px-8 sm:pb-32">
      {SECTIONS.map((s, i) => (
        <FadeUp key={s.title} delay={i * 0.05}>
          <article className="rounded-2xl border border-brass/15 bg-charcoal/50 p-8">
            <h2 className="font-serif text-2xl text-ivory">{s.title}</h2>
            <p className="mt-3 text-[15px] leading-relaxed text-ivory/70">{s.body}</p>
          </article>
        </FadeUp>
      ))}
      <FadeUp delay={0.1}>
        <p className="pt-4 text-sm leading-relaxed text-ivory/50">
          Privacy questions or requests?{" "}
          <Link to="/contact" data-testid="privacy-contact-link" className="text-brass underline underline-offset-4 hover:text-ivory">
            Contact us
          </Link>{" "}
          or email{" "}
          <a href="mailto:hello@playersloungesyd.com" className="text-brass underline underline-offset-4 hover:text-ivory">
            hello@playersloungesyd.com
          </a>
          .
        </p>
      </FadeUp>
    </section>
  </div>
);

export default Privacy;
